import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/SSL_Certificate/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menü // SSL Zertifikat",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/SSL_Zertifikat/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Sie möchten Ihr eigenes SSL-Zertifikat für Ihre eigene DDNS-Domaine verwenden? Kein Problem!",
  "image": "./WebUI_1440p_SearchThumb_Network_IP_Configuration.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Netzwerk Menü // SSL Zertifikat' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Sie möchten Ihr eigenes SSL-Zertifikat für Ihre eigene DDNS-Domaine verwenden? Kein Problem!' image='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_IP_Configuration.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/SSL_Certificate/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/SSL_Certificate/' crumbLabel="SSL" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/8f8e74c112e589d9d0b089d7c5df798e/e2e58/1440p_WebUI_Network_SSL_Certificate.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "80.8695652173913%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAAA7rAAAO6wFxzYGVAAAC60lEQVQ4y22Ta4sbVRyH90tIYbtJSGqWbG6sUGg2t5lJttttmmTmzOXMLZfexEK71mbRWrtSq6L4zi0IFrWC+kaK4Fs/gJ/AD/TInGzSoeyLh8O8mB/P//87Z6Ner1OtVqnWapSKBTT5kPFnrzl4+Ir+h7+iH73CSJF8949+QZy8piEeoLUblCsVNjc3yeWybJTLZRIqlSrFS3n2nbvMnv6Ev/geefwCb5FwqpCLF2ecMj/5mcPgPntXGly+3KBW26Ve32VjZ2eHSqWi2N7eRmvvMQ1sYmmtmZydkWcSumMCe4A7NLCGJsNhhNbtY+gHtJraMnBpuAzUDYMwivGkr5B+gB+EOK6H7XgIy8S+tcD++Ec8MSe4HnGw36On99lrtM8x1DSCIFgShvi+j23bKQSOFzIKbnEUS55/YCNsHb1r0NzrvjFMKBaLKnA6nTKbzYiiSAULIVRYcjquSxj4mOMxjx68z9dPXMaDJobWo9PunB+4NPRVgGmaOI6DL33Fyv764AbfPDvhnx+eM9xvsW8Y6N1WuuXKOjAMQ0ViqM4wQk4kjnSwhU0Uhsr0y0+f8N8fv3FndFX912622FjtL20Yx7EiMfGVUYgbuwhXYI5N5vM58WTKV08f8+9fv/PFzQGHB31azc75gZPJcofJyJZlLTEtpJTKehJP8KTEEybCaNO7Uue93RqlUvnNyG8bJqOuylCF2EI1nl5Hs9ninQsX2MrmyGZz5HK58wP9MCKaTNWe0g1LmQQGBL5UTWvdLrlslkKhQD6fV6xHXpVi6DrzyFUvw3NS989xzk4X2wvxwyndrkYmk1mHrQNXhpfeLXKtr/Hn5xZ/Pxtyb2IyMm2cxNAaI0bXsPwZ5icvcR6/pGNcJbN1kXzasFQqkZDcx+XIunpiY1MgxJmdsHCiu9h3jgnC2xwNBnxkCYxOh61MhkLaMAlasdqhm+zOshDCWjZtjnBuH+MuTpnNH/Ht4Q2+Mx167TYX3wr8H0PdTtIG4kOoAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8f8e74c112e589d9d0b089d7c5df798e/e4706/1440p_WebUI_Network_SSL_Certificate.avif 230w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/d1af7/1440p_WebUI_Network_SSL_Certificate.avif 460w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/7f308/1440p_WebUI_Network_SSL_Certificate.avif 920w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/c986f/1440p_WebUI_Network_SSL_Certificate.avif 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/8f8e74c112e589d9d0b089d7c5df798e/a0b58/1440p_WebUI_Network_SSL_Certificate.webp 230w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/bc10c/1440p_WebUI_Network_SSL_Certificate.webp 460w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/966d8/1440p_WebUI_Network_SSL_Certificate.webp 920w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/b8544/1440p_WebUI_Network_SSL_Certificate.webp 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/8f8e74c112e589d9d0b089d7c5df798e/81c8e/1440p_WebUI_Network_SSL_Certificate.png 230w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/08a84/1440p_WebUI_Network_SSL_Certificate.png 460w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/c0255/1440p_WebUI_Network_SSL_Certificate.png 920w", "/de/static/8f8e74c112e589d9d0b089d7c5df798e/e2e58/1440p_WebUI_Network_SSL_Certificate.png 1069w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/8f8e74c112e589d9d0b089d7c5df798e/c0255/1440p_WebUI_Network_SSL_Certificate.png",
              "alt": "Web User Interface - 1440p Series - Network SSL Certificate",
              "title": "Web User Interface - 1440p Series - Network SSL Certificate",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h2 {...{
      "id": "formatierung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#formatierung",
        "aria-label": "formatierung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Formatierung`}</h2>
    <p>{`Die korrekte Formatierung ist wichtig, da die Kamera ansonsten das digitale Zertifikat nicht annimmt. Die Kamera verwendet Zertifikate im PEM-Format. Die Zertifikatsdatei muss demnach die Dateierweiterung `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.pem`}</code>{` besitzen.`}</p>
    <p>{`Unten sehen Sie ein blankes Beispielzertifikat. Sie benötigen Ihren privaten Schlüssel (Private RSA Key oder Private Key) und das X.509-Zertifikat, welcher Ihren öffentlichen Schlüssel enthält und Sie von Ihrer Zertifizierungsstelle erhalten haben.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "yaml"
    }}><pre parentName="div" {...{
        "className": "language-yaml"
      }}><code parentName="pre" {...{
          "className": "language-yaml"
        }}><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`BEGIN RSA PRIVATE KEY`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`
MIIEogIBAAKCAQEAwONaLOP7EdegqjRuQKSDXzvHmFMZfBufjhELhNjo5KsL4ieH
hMSGCcSV6y32hzhqR5lvTViaQez+xhc58NZRu+OUgEhodRBW/vAOjpz/xdMz5HaC
EhP3E9W1pkitVseS8B5rrgJo1BfCGai1fPav1nutPq2Kj7vMy24+g460Lonf6ln1
di4aTIRtAqXtUU6RFpPJP35PkCXbTK65O8HJSxxt/XtfoezHCU5+UIwmZGYx46UB
Wzg3IfK6bGPSiHU3pdiTol0uMPt/GUK+x4NyZJ4/ImsNAicRwMBdja4ywHKXJehH
gXBthsVIHbL21x+4ibsg9eVM/XioTV6tW3IrdwIDAQABAoIBACFfdLutmkQFBcRN
HAJNNHmmsyr0vcUOVnXTFyYeDXV67qxrYHQlOHe6LqIpKq1Mon7O2kYMnWvooFAP
trOnsS6L+qaTYJdYg2TKjgo4ubw1hZXytyB/mdExuaMSkgMgtpia+tB5lD+V+LxN
x1DesZ+veFMO3Zluyckswt4qM5yVa04YFrt31H0E1rJfIen61lidXIKYmHHWuRxK
SadjFfbcqJ6P9ZF22BOkleg5Fm5NaxJmyQynOWaAkSZa5w1XySFfRjRfsbDr64G6
+LSG8YtRuvfxnvUNhynVPHcpE40eiPo6v8Ho6yZKXpV5klCKciodXAORsswSoGJa
N3nnu/ECgYEA6Yb2rM3QUEPIALdL8f/OzZ1GBSdiQB2WSAxzl9pR/dLF2H+0pitS
to0830mk92ppVmRVD3JGxYDRZQ56tlFXyGaCzJBMRIcsotAhBoNbjV0i9n5bLJYf
BmjU9yvWcgsTt0tr3B0FrtYyp2tCvwHqlxvFpFdUCj2oRw2uGpkhmNkCgYEA03M6
WxFhsix3y6eVCVvShfbLBSOqp8l0qiTEty+dgVQcWN4CO/5eyaZXKxlCG9KMmKxy
Yx+YgxZrDhfaZ0cxhHGPRKEAxM3IKwT2C8/wCaSiLWXZZpTifnSD99vtOt4wEfrG
+AghNd5kamFiM9tU0AyvhJc2vdJFuXrfeC7ntM8CgYBGDA+t4cZcbRhu7ow/OKYF
kulP3nJgHP/Y+LMrl3cEldZ2jEfZmCElVNQvfd2XwTl7injhOzvzPiKRF3jDez7D
g8w0JAxceddvttJRK9GoY4l7OoeKpjUELSnEQkf+yUfOsTbXPXVY7jMfeNL6jE6b
qN7t3qv8rmXtejMBE3G6cQKBgGR5W2BMiRSlxqKx1cKlrApV87BUe1HRCyuR3xuA
d6Item7Lx1oEi7vb242yKdSYnpApWQ06xTh83Y/Ly87JaIEbiM0+h+P8OEIg0F1a
iB+86AcUX1I8KseVy+Np0HbpfwP8GrFfA5DaRPK7pXMopEtby8cAJ1XZZaI1/ZvZ
BebHAoGAcQU9WvCkT+nIp9FpXfBybYUsvgkaizMIqp66/l3GYgYAq8p1VLGvN4v5
ec0dW58SJrCpqsM3NP78DtEzQf9OOsk+FsjBFzDU2RkeUreyt2/nQBj/2mN/+hEy
hYN0Zii2yTb63jGxKY6gH1R/r9dL8kXaJmcZrfSa3AgywnteJWg=
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`END RSA PRIVATE KEY`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`BEGIN CERTIFICATE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`
MIIDBjCCAe4CCQCX05m0b053QzANBgkqhkiG9w0BAQQFADBFMQswCQYDVQQGEwJB
VTETMBEGA1UECBMKU29tZS1TdGF0ZTEhMB8GA1UEChMYSW50ZXJuZXQgV2lkZ2l0
cyBQdHkgTHRkMB4XDTA4MTIwNzEwMjUyMloXDTE4MTIwNTEwMjUyMlowRTELMAkG
A1UEBhMCQVUxEzARBgNVBAgTClNvbWUtU3RhdGUxITAfBgNVBAoTGEludGVybmV0
IFdpZGdpdHMgUHR5IEx0ZDCCASIwDQYJKoZIhvcNAQEBBQADggEPADCCAQoCggEB
AMDjWizj+xHXoKo0bkCkg187x5hTGXwbn44RC4TY6OSrC+Inh4TEhgnElest9oc4
akeZb01YmkHs/sYXOfDWUbvjlIBIaHUQVv7wDo6c/8XTM+R2ghIT9xPVtaZIrVbH
kvAea64CaNQXwhmotXz2r9Z7rT6tio+7zMtuPoOOtC6J3+pZ9XYuGkyEbQKl7VFO
kRaTyT9+T5Al20yuuTvByUscbf17X6HsxwlOflCMJmRmMeOlAVs4NyHyumxj0oh1
N6XYk6JdLjD7fxlCvseDcmSePyJrDQInEcDAXY2uMsBylyXoR4FwbYbFSB2y9tcf
uIm7IPXlTP14qE1erVtyK3cCAwEAATANBgkqhkiG9w0BAQQFAAOCAQEAW4yZdqpB
oIdiuXRosr86Sg9FiMg/cn+2OwQ0QIaA8ZBwKsc+wIIHEgXCS8J6316BGQeUvMD+
plNe0r4GWzzmlDMdobeQ5arPRB89qd9skE6pAMdLg3FyyfEjz3A0VpskolW5VBMr
P5R7uJ1FLgH12RyAjZCWYcCRqEMOffqvyMCH6oAjyDmQOA5IssRKX/HsHntSH/HW
W7slTcP45ty1b44Nq22/ubYk0CJRQgqKOIQ3cLgPomN1jNFQbAbfVTaK1DpEysrQ
5V8a8gNW+3sVZmV6d1Mj3pN2Le62wUKuV2g6BNU7iiwcoY8HI68aRxz2hVMS+t5f
SEGI4JSxV56lYg==
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span>{`END CERTIFICATE`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`---`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`-`}</span></code></pre></div>
    <h2 {...{
      "id": "private-rsa-key-oder-private-key",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#private-rsa-key-oder-private-key",
        "aria-label": "private rsa key oder private key permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`"Private RSA Key" oder "Private Key"?`}</h2>
    <p>{`Sie benötigen nur einen! Welchen Schlüssel Sie hier verwenden ist egal, solange dieser korrekt ausgewiesen ist.`}</p>
    <p>{`Mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----BEGIN RSA PRIVATE KEY-----`}</code>{` setzen Sie den Beginn des "Private RSA Key" fest und mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----END RSA PRIVATE KEY-----`}</code>{` setzen Sie das Ende fest.`}</p>
    <p>{`Mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----BEGIN PRIVATE KEY-----`}</code>{` setzen Sie den Beginn des "Private Key" fest und mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----END PRIVATE KEY-----`}</code>{` setzen Sie das Ende fest.`}</p>
    <p>{`Neben einem der oben genannten privaten Schlüssel benötigen Sie noch das X.509-Zertifikat mit Ihrem öffentlichen Schlüssel (Public Key).`}</p>
    <p>{`Mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----BEGIN CERTIFICATE-----`}</code>{` setzen Sie den Beginn des X.509-Zertifikats fest. Mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`-----END CERTIFICATE-----`}</code>{` setzen Sie das Ende fest.`}</p>
    <h2 {...{
      "id": "wichtiger-hinweis",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#wichtiger-hinweis",
        "aria-label": "wichtiger hinweis permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Wichtiger Hinweis!`}</h2>
    <p>{`Wichtig ist, dass der Private RSA Key oder der Private Key zum X.509-Zertifikat passt. Sollten die HASH-Werte nicht übereinstimmen, so wird das Zertifikat von der Kamera verworfen.`}</p>
    <p>{`Möchten Sie das Zertifikat wechseln, so muss die Kamera im Anschluss neu gestartet werden. Erst dann wird das neu ausgewählte Zertifikat gültig sein.`}</p>
    <h2 {...{
      "id": "mqtt-ftps-und-https-alarmserver",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#mqtt-ftps-und-https-alarmserver",
        "aria-label": "mqtt ftps und https alarmserver permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`MQTT, FTPS und HTTPS Alarmserver`}</h2>
    <p>{`Wenn Sie hier ein privates Zertifikat hochladen, wird dieses neben der `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/IP_Configuration/"
      }}>{`HTTPS Verbindung`}</a>{` über Ihre `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/Remote_Access/"
      }}>{`INSTAR DDNS Adresse`}</a>{` auch für den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/MQTT/"
      }}>{`INSTAR MQTT Broker`}</a>{`, den `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Smarthome/Alarm_Server/"
      }}>{`HTTPS Alarmserver`}</a>{` und `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Features/FTP/"
      }}>{`FTPS Dienst`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      